module.exports = __webpack_public_path__ + "static/media/logoFERIT_wide_hr.c66dceb9.png";